import { render, staticRenderFns } from "./UPreloader.vue?vue&type=template&id=2987d826&scoped=true"
import script from "./UPreloader.vue?vue&type=script&lang=js"
export * from "./UPreloader.vue?vue&type=script&lang=js"
import style0 from "./UPreloader.vue?vue&type=style&index=0&id=2987d826&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2987d826",
  null
  
)

export default component.exports